import { render, staticRenderFns } from "./BusinessJoinStep2.vue?vue&type=template&id=53b05f04&"
import script from "./BusinessJoinStep2.vue?vue&type=script&lang=js&"
export * from "./BusinessJoinStep2.vue?vue&type=script&lang=js&"
import style0 from "./BusinessJoinStep2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports